<div class="container">
  <div class="close" (click)="dialogRef.close()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <div div class="content">
    <div class="title-section">
      <h1 class="title">Cambiá tu contraseña</h1>
      <h3 class="subtitle">Actualizá tu contraseña</h3>
    </div>
    <div class="signin-form">
      <div class="form" (keyup.enter)="updatePassword()">
        <mat-form-field appearance="outline">
          <input
            matInput
            [type]="seePassword ? 'text' : 'password'"
            placeholder="Ingresa tu contraseña actual"
            name="password"
            [formControl]="passwordControl"
            (keyup)="checkForMatch($event)"
          />
          <img
            class="eye-icon"
            src="assets/icons/eye.svg"
            *ngIf="!seePassword"
            (click)="seePassword = true"
            alt=""
          />
          <img
            class="eye-off-icon"
            src="assets/icons/eye-off.svg"
            *ngIf="seePassword"
            (click)="seePassword = false"
            alt=""
          />
          <mat-error
            for="register-password"
            class="form-error"
            *ngIf="
              (!passwordControl.pristine || passwordControl.touched) && passwordControl.invalid
            "
          >
            {{ getErrorMessage('password') }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input
            matInput
            [type]="seePassword ? 'text' : 'password'"
            placeholder="Ingresa nueva contraseña"
            name="newPass"
            [formControl]="newPassword"
            (keyup)="checkForMatch($event)"
          />
          <img
            class="eye-icon"
            src="assets/icons/eye.svg"
            *ngIf="!seePassword"
            (click)="seePassword = true"
            alt=""
          />
          <img
            class="eye-off-icon"
            src="assets/icons/eye-off.svg"
            *ngIf="seePassword"
            (click)="seePassword = false"
            alt=""
          />
          <mat-error
            for="register-password"
            class="form-error"
            *ngIf="(!newPassword.pristine || newPassword.touched) && newPassword.invalid"
          >
            {{ getErrorMessage('newPass') }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input
            matInput
            [type]="seePassword ? 'text' : 'password'"
            placeholder="Repite nueva contraseña"
            name="repeatNewPass"
            [formControl]="repeatNewPassword"
            (keyup)="checkForMatch($event)"
          />
          <img
            class="eye-icon"
            src="assets/icons/eye.svg"
            *ngIf="!seePassword"
            (click)="seePassword = true"
            alt=""
          />
          <img
            class="eye-off-icon"
            src="assets/icons/eye-off.svg"
            *ngIf="seePassword"
            (click)="seePassword = false"
            alt=""
          />
          <mat-error
            for="register-password"
            class="form-error"
            *ngIf="
              (!repeatNewPassword.pristine || repeatNewPassword.touched) &&
              repeatNewPassword.invalid
            "
          >
            {{ getErrorMessage('repeatNewPass') }}
          </mat-error>
        </mat-form-field>
      </div>
      <button class="td-btn primary buttonChange" (click)="updatePassword()">Actualizar</button>
    </div>
  </div>
</div>
